import React, { useState, useEffect } from 'react';

export type ToastType = 'success' | 'error' | 'info';

export interface Toast {
  id: string;
  message: string;
  type: ToastType;
}

let toastListeners: Array<(toasts: Toast[]) => void> = [];
let toasts: Toast[] = [];

const notifyListeners = (): void => {
  toastListeners.forEach(listener => listener([...toasts]));
};

export const showToast = (message: string, type: ToastType = 'info'): void => {
  const id = Math.random().toString(36).substring(7);
  toasts = [...toasts, { id, message, type }];
  notifyListeners();

  setTimeout(() => {
    toasts = toasts.filter(t => t.id !== id);
    notifyListeners();
  }, 3000);
};

export const useToasts = (): Toast[] => {
  const [state, setState] = useState<Toast[]>(toasts);

  useEffect(() => {
    toastListeners.push(setState);
    return () => {
      toastListeners = toastListeners.filter(l => l !== setState);
    };
  }, []);

  return state;
};

export const ToastContainer: React.FC = () => {
  const toasts = useToasts();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-[10002] space-y-2" dir="rtl">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={`px-6 py-3 rounded-lg shadow-lg text-white min-w-[250px] animate-slide-in ${
            toast.type === 'success' ? 'bg-green-600' :
            toast.type === 'error' ? 'bg-red-600' :
            'bg-blue-600'
          }`}
          role="alert"
          aria-live="polite"
        >
          {toast.message}
        </div>
      ))}
    </div>
  );
};

